import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useGuestOrderType } from '../../hooks/useGuestOrderType';
import { withGuestOrderTypeQuery } from '../../utils/guestOrderTypeStorage';
import { useKioskMode } from '../../contexts/KioskModeContext';
import { mapRestaurantPathToKiosk } from './kioskPaths';

/** Map `/restaurants/:app/...` links to `/kiosk/:app/...` when kiosk shell is active. */
export function useKioskGuestOrderingPath(): (restaurantsPath: string) => string {
  const { appName: paramApp } = useParams<{ appName: string }>();
  const { enabled, appName: ctxApp } = useKioskMode();
  const appName = paramApp || ctxApp || undefined;
  const guestOrderType = useGuestOrderType(appName);

  return useCallback(
    (restaurantsPath: string) => {
      if (!enabled || !appName) {
        return restaurantsPath;
      }
      const mapped = mapRestaurantPathToKiosk(appName, restaurantsPath);
      return withGuestOrderTypeQuery(mapped, appName, guestOrderType);
    },
    [appName, enabled, guestOrderType]
  );
}
